import PropTypes from "prop-types"
import React from "react"
import {
  Collapse,
  Col,
  Container,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Row
} from 'reactstrap'
import {GatsbyImage} from 'gatsby-plugin-image'
import {StaticQuery, graphql, Link} from 'gatsby'

class Header extends React.Component  {
  constructor(props){
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen:false
    }
  }
  toggle(){
    this.setState({isOpen: !this.state.isOpen});
  }
  
  
  render(){        
    const headerQuery = graphql`
    query siteLogoQuery {
      file(relativePath: { eq: "logo.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
    `
    var brand = (
          <StaticQuery query={headerQuery} render={(data)=>(
              <Col md="12">
                <Link to="/">
                  <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} alt="Logo" style={{width: "100%", height:"100%"}} />
                </Link>
              </Col>
          )}/>
    )

  return (
    <Container>
      <Row className="branding">
        {brand}
      </Row>     
      <Row className="navBar">
          <Navbar dark expand="sm">
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem>
                  <NavLink href="/">Home</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/about/">About</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/episodes/1">Episodes</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/posts/1">Posts</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/authors/1">Authors</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/guests/1">Guests</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/sponsors/1">Sponsors</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/books/1">Books</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="https://www.Patreon.com/CompleteDeveloperPodcast">Patreon</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/Books/">Books</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/Talks/">Talks</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="https://slack.completedevelopernetwork.com">Slack Signup</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/feed/podcast.xml">
                    <i className="fa fa-rss"/>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="https://www.Facebook.com">
                    <i className="fab fa-facebook-square"/>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="https://www.twitter.com">
                    <i className="fab fa-twitter-square"/>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="https://www.LinkedIn.com">
                    <i className="fab fa-linkedin"/>
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>   
      </Row>     
    </Container>
  );
}
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  siteLogo: PropTypes.string
}

Header.defaultProps = {
  siteTitle: ``,
  siteLogo: `images/Logo.jpg`
}

export default Header
